export default {
  'CONVERSATIONS' (state) {
    return state.conversations
  },
  'CONVERSATION' (state) {
    return state.conversation
  },
  'MESSAGES' (state) {
    return state.messages
  },
  'TEMPLATES' (state) {
    return state.templates
  },
  'SESSION_ACTIVE' (state) {
    return state.sessionActive
  },
  'SESSION_EXPIRES_AT' (state) {
    return state.sessionExpiresAt
  },
  'LOADING' (state) {
    return state.loading
  }
}
